import React from 'react';

type Props = {
  uri: string;
  width: number;
  height: number;
};

export default function MyImageComponent(props: Props) {
  const {uri, width, height} = props;

  return (
    <img
      src={uri}
      alt="Scaled Image"
      style={{
        maxWidth: '100%',
        width: width,
        height: height,
        objectFit: 'contain',
      }}
    />
  );
}
